import React from 'react';

import { Image } from 'expo-image';

export const HeaderFlair = () => {
  return (
    <>
      <Image
        style={{ width: 46, aspectRatio: 1, position: 'absolute', left: '-1%', top: '10%' }}
        source={require('./flower-2.svg')}
      />
      <Image
        style={{ width: 80, aspectRatio: 1, position: 'absolute', left: '25%', top: '-25%' }}
        source={require('./flower-3.svg')}
      />
      <Image
        style={{ width: 50, aspectRatio: 1, position: 'absolute', right: '12%', top: '-20%' }}
        source={require('./flower-1.svg')}
      />
    </>
  );
};
